<div class="container">
  @if (apiLoaded | async) {
    <div>
      <google-map [options]="mapOptions" [zoom]="mapOptions.zoom" [center]="center" [width]="mapOptions.width"
        [height]="mapOptions.height" (mapClick)="onMapClick($event)">
        <map-marker [position]="marker?.position" [options]="marker?.options"></map-marker>
      </google-map>
    </div>
  }
  <div class="row" [class.hide]="readOnly">
    <mat-form-field>
      <mat-label>Search location</mat-label>
      <input #searchInput matInput type="text" autocomplete="off" />
    </mat-form-field>
  </div>
  @if (enableLocationSection) {
    <div class="row">
      <app-text-area
        [parentFormGroup]="locationForm"
        controlName="location"
        label="Location"
        placeholder="Enter location"
      />
    </div>
  }
  @if (!readOnly && showIncludeGpsLocationCheckbox) {
    <div class="row include-gps-row">
      <mat-checkbox
        [(ngModel)]="includeGps"
        color="primary"
      >Include GPS location</mat-checkbox>
    </div>
  }
  @if (apiLoaded | async) {
    <div class="row" [class.hide]="readOnly">
      <app-secondary-button (handleClick)="cancel()">Cancel</app-secondary-button>
      <app-primary-button (handleClick)="close()" [isDisabled]="isDoneDisabled">Done</app-primary-button>
    </div>
  }
</div>
